import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { combineReducers } from 'redux';

import trapPageReducer from '../pages/Traps/Slice/trapSlice';
import reportsPageReducer from '../pages/Reports/Slice/reportSlice';
import analiticsPageReducer from '../pages/ObjectAnalitics/Slice/analyticsSlice';
import visitsAndScheduledTasksPageSliceReducer from '../pages/VisitsAndScheduleTasks/Slice/visitsAndTasksSlice';
import devicesDetailPageSliceReducer from '../pages/DevicesDetail/Slice/devicesDetailSlice';
import devicesDetailPageSliceSRBM from '../pages/DevicesDetail/Slice/devicesDetailSliceSRBM';
import clientsReducer from '../pages/ClientDashboardV2/Slice/clientsSlice';

import UserReducer from './login/reducer';
import LayoutReducer from './sidebar/reducer';

const rootReducer = combineReducers({
  User: UserReducer,
  Layout: LayoutReducer,
  Traps: trapPageReducer,
  Reports: reportsPageReducer,
  Analitics: analiticsPageReducer,
  VisitsAndScheduledTasksTable: visitsAndScheduledTasksPageSliceReducer,
  DevicesDetailPages: devicesDetailPageSliceReducer,
  DevicesDetailPagesSRBM: devicesDetailPageSliceSRBM,
  ClientsBody: clientsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export default rootReducer;
export type RootReducerType = typeof rootReducer;
export type AppDispatchType = typeof store.dispatch;
export type AppRootStateType = ReturnType<RootReducerType>;
export const useAppDispatch: () => AppDispatchType = useDispatch;
export const useAppSelector: TypedUseSelectorHook<AppRootStateType> = useSelector;
